var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf-svgrepo-com 2",
    clipPath: "url(#clip0_1343_2866)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.99999 0H10.4965L15 4.48601V15C15 15.5525 14.552 16 14 16H1.99999C1.44798 16 1 15.5525 1 15V0.99999C1 0.44751 1.44803 0 1.99999 0Z",
    fill: "#E2574C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.9855 4.50001H11.5C10.948 4.50001 10.5 4.05203 10.5 3.50002V0.0100098L14.9855 4.50001Z",
    fill: "#B53629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.2489 7.58148C11.4164 7.58148 11.4984 7.43549 11.4984 7.29399C11.4984 7.14748 11.4129 7.00598 11.2489 7.00598H10.2949C10.1084 7.00598 10.0044 7.16046 10.0044 7.33098V9.67547C10.0044 9.88448 10.1234 10.0005 10.2844 10.0005C10.4444 10.0005 10.5639 9.88448 10.5639 9.67547V9.03198H11.1409C11.3199 9.03198 11.4094 8.88547 11.4094 8.73999C11.4094 8.59751 11.3199 8.45597 11.1409 8.45597H10.5639V7.58148H11.2489ZM8.02438 7.00598H7.32637C7.13686 7.00598 7.00235 7.13599 7.00235 7.32896V9.67749C7.00235 9.91697 7.19584 9.99198 7.33433 9.99198H8.06685C8.93383 9.99198 9.50633 9.4215 9.50633 8.54097C9.50587 7.60999 8.96689 7.00598 8.02438 7.00598ZM8.0579 9.41302H7.63238V7.585H8.01589C8.59642 7.585 8.84888 7.97452 8.84888 8.51199C8.84888 9.01502 8.60086 9.41302 8.0579 9.41302ZM5.50089 7.00598H4.8094C4.61389 7.00598 4.50488 7.13496 4.50488 7.33098V9.67547C4.50488 9.88448 4.62987 10.0005 4.79786 10.0005C4.96584 10.0005 5.09084 9.88448 5.09084 9.67547V8.99096H5.52433C6.05932 8.99096 6.50083 8.61195 6.50083 8.00245C6.50088 7.406 6.07489 7.00598 5.50089 7.00598ZM5.4894 8.44101H5.09089V7.5565H5.4894C5.73541 7.5565 5.8919 7.74849 5.8919 7.99899C5.89139 8.24902 5.73541 8.44101 5.4894 8.44101Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1343_2866"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.245cd2564f5da53e5f4f498fb75a1b13.svg";
export { ForwardRef as ReactComponent };